import * as React from "react";

interface GenPanelProps {
  className?: string
  children: React.ReactNode;
}

export default function GenPanel(
  {
    className,
    children,
  }: GenPanelProps,
) {
  return (
    <div className={`gen-panel ${className}`}>
      {children}
    </div>
  );
}
